import React from 'react';
import './EmptyStateComponent.scss';
import { teslaCacheX } from '../../Shift';
import ReactPlayer from 'react-player';
import Logger from '../../Logger';
import ScreenService from '../../services/ScreenService';
class EmptyStateComponent extends React.Component {

    //keep this code commented because now it has a solid background but it will be changed again
    constructor(props) {
        super(props);
        
        this.resources = ScreenService.isVertical 
        ? { url: 'https://cdn.upshow.tv/no-content-vertical.mp4', poster: 'https://cdn.upshow.tv/no-content-vertical.jpg' } 
        : { url: 'https://cdn.upshow.tv/no_content.mp4', poster: 'https://cdn.upshow.tv/no-content.jpg' };

        this.url = teslaCacheX(this.resources.url);
    }

    render() {
        return <div className="empty-state">
            {/*<ReactPlayer
                width="100%" height="100%" volume={0} playing loop
                url={this.url}
                onError={(error) => Logger.warn('No Content state could not play loading media', error)}
                config={{
                    file: {
                        attributes: {
                            crossOrigin: 'anonymous',
                            poster: this.resources.poster
                        }
                    }
                }} />*/}
            <div className="empty-state-left">
                <div className="logo">
                    <img alt="logo" src='https://cdn.shiftplatform.tv/ui_assets/logo-shift-ui-small.svg'/>
                </div>
                <h2 className="title">No content to display at the moment.</h2>
                <div className="contact">
                    <div className="contact-text">If you need assistance, please contact:</div>
                    <strong>support@shiftplatform.tv</strong>
                </div>
            </div>
            <div className="empty-state-right">
                <img alt="empty state image" src='https://cdn.shiftplatform.tv/ui_assets/noContentToDisplay.svg'/>
            </div>
        </div>;
    }
}

export default EmptyStateComponent;